import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';

import { apiGetModel, baseRequestParams } from '../../useApiHook';
import { callAxios } from '../../../services/callAPIMiddleware';

export const useFetchClinicianGroups = (params, forceReload) => {
  const auth = useSelector(state => state.global.auth);
  const jwtToken = auth.jwtToken;
  const [state, setState] = useState({ response: null, isDataLoading: true, refresh: forceReload });
  const [error, setError] = useState(null);
  const [isUpdateTriggered, setIsUpdateTriggered] = useState(true);

  // Prepare api model and request call
  const getModel = apiGetModel('GetClinicianGroups', params, forceReload);
  const setRequestResponse = response => {
    setState({ ...state, response, isDataLoading: false, refresh: forceReload });
    setIsUpdateTriggered(false);
  };

  useEffect(() => {
    if (jwtToken) {
      setIsUpdateTriggered(true);
      callAxios(auth, getModel.url, getModel.method, getModel.data)
        .then(result => setRequestResponse(result.data))
        .catch(ex => {
          setError(ex.mesage);
          setState({ ...state, isDataLoading: false });
          setIsUpdateTriggered(false);
        });
    }
  }, [jwtToken, getModel.url, getModel.reloadData]);

  // Returning strongly-type mappedDto object

  if (state.response === null) {
    state.response = [];
  } else {
    state.response.mappedClinicianGroups = state.response.clinicianGroups.map(g => {
      return {
        id: g.id,
        name: g.name,
        clinicianNames: g.clinicians.map(c => c.name).join(', '),
        clinicianOptions: g.clinicians,
        orgUnitOption: g.orgUnit,
        orgUnitName: g.orgUnit.name,
        validFrom: g.validFrom,
        validTo: g.initialValidTo,
      };
    });
  }

  return {
    data: state.response,
    isDataLoading: state.isDataLoading,
    auth,
    error,
    isUpdateTriggered,
  };
};

export const useFetchClinicianGroupsOnDay = forceReload => {
  const auth = useSelector(state => state.global.auth);
  const jwtToken = auth.jwtToken;
  const [state, setState] = useState({ response: null, isDataLoading: true, refresh: forceReload });
  const [error, setError] = useState(null);
  const [isUpdateTriggered, setIsUpdateTriggered] = useState(true);

  const baseRequestModel = baseRequestParams();
  // Prepare api model and request call
  const getModel = apiGetModel('GetClinicianGroupsOnDay', baseRequestModel, forceReload);
  const setRequestResponse = response => {
    setState({ ...state, response, isDataLoading: false, refresh: forceReload });
    setIsUpdateTriggered(false);
  };

  useEffect(() => {
    if (jwtToken) {
      setIsUpdateTriggered(true);
      callAxios(auth, getModel.url, getModel.method, getModel.data)
        .then(result => setRequestResponse(result.data))
        .catch(ex => {
          setError(ex.mesage);
          setState({ ...state, isDataLoading: false });
          setIsUpdateTriggered(false);
        });
    }
  }, [jwtToken, getModel.url, getModel.reloadData]);

  // Returning strongly-type mappedDto object

  if (state.response === null) {
    state.response = [];
  } else {
    state.response.mappedClinicianGroups = state.response.clinicianGroups.map(g => {
      return {
        id: g.id,
        name: g.name,
        clinicianNames: g.clinicians.map(c => c.name).join(', '),
        clinicianIds: g.clinicians.map(c => c.id),
        orgUnitName: g.orgUnit.name,
        isValidOnDay: g.isValidOnDay,
        reasonMsg: g.isInvalidMessage,
      };
    });
  }

  return {
    data: state.response,
    isDataLoading: state.isDataLoading,
    auth,
    error,
    isUpdateTriggered,
  };
};
